import { render } from "./studentroom.vue?vue&type=template&id=4fec99fc"
import script from "./studentroom.vue?vue&type=script&lang=js"
export * from "./studentroom.vue?vue&type=script&lang=js"

import "./studentroom.vue?vue&type=style&index=0&id=4fec99fc&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__